<template>
    <div class="row">
        <div class="col-12">
            <label class="form-label">Takip Gerekçesi</label>
            <v-validator :errors="errors" parameter="Name" :watch="value.Name">
                <input type="text" v-model="value.Name" class="form-control" placeholder="Takip Gerekçesi"/>
            </v-validator>
        </div>
    </div>
</template>

<script>
export default {
    props:{
        value:Object,
        errors:Object
    }
}
</script>

<style>

</style>